module.exports = __webpack_public_path__ + "poppins-v6-latin-600.woff2";